import axios from 'axios';
import { setAccessToken, setUserId, setUserRole } from '../Utils/AuthUtil';
import { LoginResponse, ResetPassword } from '../types';

const baseUrl = process.env.REACT_APP_UMS_API_URL || '';

const password_host = process.env.REACT_APP_RESET_PASSWORD_HOST;

export async function loginUser(
	email: string,
	password: string,
): Promise<LoginResponse | undefined> {
	const body = `client_id=senzmatemlums-client&client_secret=senzmatemlums-secret&grant_type=password&username=${email}&password=${password}`;
	try {
		const response = await axios.post(`${baseUrl}/oauth/token`, body);
		setAccessToken(response.data.access_token);
		setUserRole(response.data.role);
		setUserId(response.data.id);

		if (response.status === 200 && response.data.role === 1000) {
			return {
				data: {
					status: response.status,
					role: response.data.role,
					userId: response.data.id,
					token: response.data.access_token,
				},
				error: false,
				message: '',
			};
		} else {
			throw { response: { status: 400 } };
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			console.log(error);

			return {
				error: true,
				message: error.message,
				data: {
					status: error.response?.status || 0,
					role: 0,
					userId: '',
					token: '',
				},
			};
		} else {
			console.error('Something went wrong', error);
		}
	}
}

export async function fetchUser(id: string, token: string) {
	try {
		const response = await axios.get(`${baseUrl}/user/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function fetchAdminUser(id: string, token: string) {
	try {
		const response = await axios.get(`${baseUrl}/admin/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function resetUserPassword(body: ResetPassword) {
	try {
		const response = await axios.post(
			`${baseUrl}/reset/resetPassword`,
			body,
		);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function generateResetUserPasswordLink(email: string) {
	const body = {
		email: email,
		host: password_host,
	};

	try {
		const response = await axios.post(
			`${baseUrl}/reset/request-resetPassword`,
			body,
		);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function updateUser(
	id: string,
	token: string,
	body: { userAccountVersion: string },
) {
	try {
		const response = await axios.put(`${baseUrl}/user/${id}`, body, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}
